<template>
    <div class="category">
        <div class="category-info">
            <h1>{{ (category && category.name) }}</h1>
            <p>{{ (category && category.description) }}</p>
        </div>
        <app-videos v-bind:videos="videos"></app-videos>
        <div v-if="this.user && category.hasQuestionnaire">
            <h2 id="documents">Questionnaire</h2>
            <div v-if="category" class="questionnaire">
                <button v-if="validCategory(category.id)[0] === 'none'" class="questionnaire-button" @click="startQuestionnaire()">Commencer le quiz</button>
                <div v-else>
                    <p>Vous avez déjà complété cette catégorie.</p>
                    <button class="questionnaire-button" @click="showResults()"> Résultats</button>
                </div>
            </div>
        </div>
        <div v-if="showQuestionnaire">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container quizz" id="quizz">
                            <div class="modal-content">
                                <h2>Questionnaire : {{ category.name }}</h2>
                                <form>
                                    <div id="main" v-for="(q, idx) in questionnaire" :class="[{'none' : q.state === 0 && idx % 2 === 0}, {'none-2' : q.state === 0 && idx % 2 === 1}, {'false' : q.state === 1}, {'right' : q.state === 2}]" style="height: 160px" v-bind:key="idx">
                                        <div class="text">
                                            <h3 v-if="q.type === 1">Q.{{ idx + 1 }} {{ q.content }}</h3>
                                            <h3 v-if="q.type !== 1">Q.{{ idx + 1 }} {{ q.content }} <br/>Plusieurs réponses peuvent être cochées</h3>
                                            <div class="answer">
                                                <table>
                                                    <tr>
                                                        <td v-for="answer in q.answers" v-bind:key="answer.id">
                                                            <!-- Questionnaire -->
                                                            <input v-if="q.type === 1 && !displayErrors" type="radio" class="css-radio" :name="'answer' + q.id" :id="'answer' + answer.id" v-model="picked[idx]" :value="answer.id" />
                                                            <input v-if="q.type !== 1 && !displayErrors" type="checkbox" class="css-checkbox" :name="'answer' + q.id" :id="'answer' + answer.id" v-model="test" :value="answer.id" @click="pick(answer.id, idx)"/>
                                                            <label v-if="!displayErrors" :for="'answer' + answer.id" class="css-label">{{ answer.content }}</label>
                                                            <!-- Rendu après submit (affichage bonne et mauvaise réponse) -->
                                                            <input v-if="q.type === 1 && displayErrors" type="radio" class="css-radio" :name="'answer' + q.id" :id="'answer' + answer.id" v-model="picked[idx]" :value="answer.id" disabled/>
                                                            <input v-if="q.type !== 1 && displayErrors" type="checkbox" class="css-checkbox" :name="'answer' + q.id" :id="'answer' + answer.id" v-model="test" :value="answer.id" @click="pick(answer.id, idx)" disabled/>
                                                            <label v-if="displayErrors" :for="'answer' + answer.id" :class="answer.correct === 0 ? 'css-label-wrong' : 'css-label'">{{ answer.content }}</label>

                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="valider">
                                    <div v-if="invalid" class="error">Vous n'avez pas coché toutes les réponses !</div>
                                    <button v-if="!displayErrors" @click="sendAnswers()">Valider</button>
                                    <button v-if="!displayErrors" @click="clean()">Réinitialiser</button>

                                    <button v-if="displayErrors" @click="clean()">Recommencer</button>
                                    <button v-if="displayErrors" @click="closeQuestionnaire()">Quitter</button>
                                </div>
                                <div class="modal-footer">
                                    <slot name="footer">
                                        <button class="modal-default-button" @click="closeQuestionnaire()"></button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showQuestionnaireFeedback">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container quizz">
                            <div class="modal-header">
                                <h2 slot="header">Questionnaire</h2>
                            </div>
                            <div class="modal-body">
                                <p v-if="this.winning">Félicitations ! Vous avez completé le questionnaire avec toute les bonnes réponses</p>
                                <p v-else>Certaines réponses sont incorrectes. Cliquez sur 'Ok' pour voir vos mauvaises réponses</p>
                                <button @click="closeFeedback()">Ok</button>
                            </div>
                            <div class="modal-footer">
                                <slot name="footer">
                                    <button class="modal-default-button" @click="closeFeedback()"></button>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showQuestionnaireResults">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container quizz">
                            <div class="modal-header">
                                <h2 slot="header">Résultats</h2>
                            </div>
                            <div class="modal-body">
                                <p>En développement.</p>
                                <button @click="result=false">Ok</button>
                            </div>
                            <div class="modal-footer">
                                <slot name="footer">
                                    <button class="modal-default-button" @click="result=false"></button>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import VideosList from '@/components/VideosList'
    import CategoriesService from '../services/categories.js'
    import AuthenticationService from '../services/authentication'
    import {mapGetters} from 'vuex'

    let type = 0;

    let answerState = {
        unknown: 0,
        wrong: 1,
        right: 2
    };

    export default {
        name: 'category',
        props: ['category_code'],
        data: function () {
            return {
                user: null,
                token: null,
                category: [],
                responses: [],
                videos: [],
                picked: [],
                checked: [],
                test: [],
                questionnaire: null,
                invalid: false,
                playing: false,
                winning: false,
                displayingFeedback: false,
                displayErrors: false,
                result: false,
            }
        },
        components: {
            'app-videos': VideosList,
        },

        created: function () {
            if(localStorage.getItem("access_token")) {
                this.token = localStorage.getItem("access_token")
                this.setLoggedUser();
            }
            this.setCategory();
        },
        methods: {
            setCategory: function () {
                CategoriesService.getByCode(this.category_code).then((res) => {
                    this.category = res.body;
                    this.setVideosForCategory()
                }, (res) => {
                    console.warn(res)
                })
            },
            setVideosForCategory: function () {
                CategoriesService.getVideos(this.category.id).then((res) => {
                    this.videos = res.body;
                }, (res) => {
                    console.warn(res)
                })
            },
            getResponses: function(id) {
                CategoriesService.getResponses(id).then((res) => {
                    this.responses = res.body;
                }, (res) => {
                    console.warn(res)
                })
            },
            validCategory: function(id) {
                let result = [];
                if (!this.responses)
                    return;
                this.responses.forEach(r => {
                    if (r.category_id === id && r.answer_id === 1)
                        result.push('success')
                });
                if (result.length === 0) {
                    result.push('none')
                }
                return result;
            },
            startQuestionnaire: function() {
                this.winning = false;
                this.playing = true;
                CategoriesService.getQuestions(this.category.id).then((res) => {
                    this.setQuestionnaire(res.body);
                }, (res) => {
                    console.warn(res);
                });
            },
            setQuestionnaire: function(questionnaire) {
                this.questionnaire = questionnaire.map(q => {
                    type = 0;
                    return {
                        content: q.content,
                        id: q.id,
                        state: answerState.unknown,
                        answers: q.answers.map( a => {
                            // 'type' increments for every right answers, and is stocked in questions
                            // to see if a unique choice can be made or multiples(radio/checkbox)
                            if (a.correct > 0) {
                                type++;
                            }
                            return {
                                content: a.content,
                                correct: a.correct,
                                id: a.id,
                                checked: false,
                                quest: a.quest
                            }
                        }),
                        type: type
                    }
                });
            },
            sendAnswers: function() {
                CategoriesService.checkAnswers(this.questionnaire).then((res) => {
                    this.invalid = false;
                    let wrongIds = 0;
                    // Check if all the elements are picked, if not, return error
                    if (this.picked.length !== this.questionnaire.length || this.picked.includes(undefined)) {
                        this.invalid = true;
                        return;
                    }
                    // See if an element is wrong in the picked array
                    this.picked.forEach(pick => {
                        // total is a comparator to see if all elements of a question are being checked
                        // index is to bind the answer that was wrong to her question when i need to make it wrong
                        let total = 0;
                        let index = 0;
                        let wrong = 0;
                        res.body.forEach(a => {
                            // picked array contains array elements and elements that are only ids,
                            // this if statement check the array case
                            if (Array.isArray(pick)) {
                                pick.forEach(p => {
                                    if (a.id === p) {
                                        index = a.quest - 1;
                                        total++;
                                        if(!a.success) {
                                            wrong++;
                                            wrongIds++;
                                            this.questionnaire[a.quest - 1].state = answerState.wrong;
                                        }
                                    }
                                    // If the exact amount of answer is checked and if they are correct, validates the question.
                                    if (this.questionnaire[index].type === total && wrong === 0)
                                        this.questionnaire[index].state = answerState.right;
                                })
                                // check the id case
                            } else if (a.id === pick) {
                                if (!a.success) {
                                    wrongIds++;
                                    this.questionnaire[a.quest - 1].state = answerState.wrong;
                                } else {
                                    this.questionnaire[a.quest - 1].state = answerState.right;
                                }
                            }
                        })
                    });

                    this.questionnaire.forEach(q => {
                        if (q.state === answerState.unknown) {
                            q.state = answerState.wrong;
                            wrongIds++;
                        }
                    });

                    // If all questions are answered properly, send to database that user succeeded and display the win
                    if (wrongIds === 0) {
                        this.send({user: this.user.id, answer: 1, category: this.category.id});
                        this.winning = true;
                        this.displayingFeedback = true;
                        return;
                    }
                    this.winning = false;
                    this.displayingFeedback = true;
                }, (res) => {
                    console.warn(res);
                });
            },
            send: function (params) {
                CategoriesService.sendAnswer(params).then((res) => {
                    console.log(res);
                    this.getResponses({user_id: this.user.id});
                }, (res) => {
                    console.warn(res);
                });
            },
            pick: function (id, idx) {
                let stop = false;
                // Verif if checked is empty and initialize it at idx index
                if (typeof this.checked[idx] == 'undefined')
                    this.checked[idx] = [];
                // allows the function to dont insert duplicate ids in the checked array
                this.checked[idx].forEach((c,i) => {
                    if (c === id) {
                        stop = true;
                        this.checked[idx].splice(i, 1);
                    }
                });
                if (stop === true)
                    return;
                this.checked[idx].push(id);
                // Put checked array into picked array
                this.picked[idx] = this.checked[idx];
            },
            clean: function() {
                this.invalid = false;
                this.displayErrors = false;
                this.questionnaire.forEach(q => {
                    q.state = answerState.unknown;
                    this.picked = [];
                    this.checked = [];
                    this.test = [];
                    q.answers.forEach(a => { a.checked = false; });
                });
            },
            closeQuestionnaire: function() {
                this.winning = false;
                this.playing = false;
                this.clean();
            },
            closeFeedback() {
                this.displayingFeedback = false;
                this.displayErrors = true;
                if (this.winning) {
                    this.closeQuestionnaire();
                }
            },

            showResults() {
                this.result = true;
            },

            setLoggedUser: function () {
                AuthenticationService.getUserByToken({
                    token: this.token
                }).then((res) => {
                    this.user = res.body[0];
                    this.id = this.user.id;
                    this.getResponses({user_id: this.id});
                }, (res) => {
                    console.log(res);
                });
            },
        },
        watch: {
            'category_code': function () {
                this.setCategory()
            }
        },
        computed: {
            showQuestionnaire: function() { return this.playing && !this.displayingFeedback; },
            showQuestionnaireFeedback: function() { return this.playing && this.displayingFeedback; },
            ...mapGetters(['actualUser']),
            showQuestionnaireResults: function() { return this.result }
        }
    }
</script>

<style>
    .category {
        width: 80%;
        margin: auto;
    }

    .category-info {

        position: relative;
        margin-bottom: 50px;
    }

    .category-info p, .questionnaire p {
        width: 70%;
        font-weight: bold;
        text-align: justify;
       /* padding-left: 30px; */
        margin-left : auto;
        margin-right: auto;
    }

    .category-info-part {
        position: absolute;
        width: 20%;
        left: 80%;
        top: 10%;
    }
    .category-info-part ul
    {
        padding-left:23px;
    }
    fieldset {
        border:none;
        border-top: 1px solid black;
        margin:10px;
    }
    .quizz .modal-body
    {
        width:80%;
    }

    .modal-container.quizz
    {
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #e5ebf7;
        padding: 0;
        border-radius: 17px;
        margin-top: 3%;
    }
    .modal-default-button {
        right: 14%;
        top: 10%;
        height: 34px;
        width: 33px;
    }

    .quizz table {
        margin-left: auto;
        margin-right: auto;

    }

    .quizz td {
        padding-left:40px;
        width: 25%;

    }

    .quizz .valider,
    .formation .valider{
        margin-top: 3%;
        text-align: center;
    }
    .quizz .valider button,
    .formation .valider a {
        background-color: #103479;
        border-radius: 25px;
        border: none;
        color: white;
        text-decoration: none;
        padding: 15px 32px;
        /*-webkit-transform-style: preserve-3d;*/
        /*-moz-transform-style: preserve-3d;*/
        /*transform-style: preserve-3d;*/
        font-size: 16px;
    }

    .quizz .valider h2 {
        position: relative;
        top: 50px;
        transform: translateY(-50%);
        text-align: center;
        color: white;
    }

    /* The Modal (background) */
    .quizz .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: #e5ebf7; /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .quizz .modal-content {
        border-radius: 25px;
        background-color: #e5ebf7;
        margin: auto;
        padding: 20px;
        width: 80%;
        /*-webkit-transform-style: preserve-3d;*/
        /*-moz-transform-style: preserve-3d;*/
        /*transform-style: preserve-3d;*/
    }

    #quizz h2 {
        text-align: center;
        margin-left: unset;
    }

    #quizz h2:before {
        background: unset;
    }

    /* The Close Button */
    .quizz .close {
        color: #aaaaaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }

    .quizz .close:hover,
    .quizz .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .quizz h3 {
        text-align: center;
        margin-top: 7px;
    }

    .quizz .none {
        text-align : center;
        background-color: #e5ebf7;
    }

    .quizz .none-2 {
        text-align : center;
        background-color: #d5dae5;
    }

    .quizz .right {
        text-align : center;
        background-color: #7dff83;
    }

    .quizz .false {
        text-align : center;
        background-color: #ff7d7d;
    }

    .quizz .wrong {
        background-position: 0 -49px;
    }

    .quizz input[type=radio].css-radio {
        position: absolute;
        z-index: -1000;
        left: -1000px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
    }


    .quizz input[type=radio].css-radio + label.css-label,label.css-label-wrong {
        padding-left:29px;
        height:24px; 
        display:inline-block;
        line-height:20px;
        background-repeat:no-repeat;
        background-position: 0 0;
        font-size:16px;
        vertical-align:middle;
        cursor:pointer;
    }

    .quizz input[type=radio].css-radio:checked + label.css-label {
        background-position: 0 -24px;
    }

    .quizz input[type=radio].css-radio:checked + label.css-label-wrong {
        background-position: 0 -49px;
    }

    .quizz label.css-label,label.css-label-wrong {
        background-image:url(../../static/img/questionnaire/checkbox-1.png);
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .quizz input[type=radio].css-radio + label.css-label-cross {
        padding-left:29px;
        height:24px; 
        display:inline-block;
        line-height:20px;
        background-repeat:no-repeat;
        background-position: 0 0;
        font-size: 16px;
        vertical-align:middle;
        cursor:pointer;
    }

    .quizz label.css-label-cross {
        background-image:url(../../static/img/questionnaire/cross-valide.png);
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .error {
        color: red;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .quizz input[type=checkbox].css-checkbox {
        position: absolute;
        z-index: -1000;
        left: -1000px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
    }

    .quizz input[type=checkbox].css-checkbox + label.css-label,label.css-label-wrong {
        padding-left:29px;
        height:24px;
        display:inline-block;
        line-height:20px;
        background-repeat:no-repeat;
        background-position: 0 0;
        font-size:16px;
        vertical-align:middle;
        cursor:pointer;
    }

    .quizz input[type=checkbox].css-checkbox:checked + label.css-label {
        background-position: 0 -24px;
    }

    .quizz input[type=checkbox].css-checkbox:checked + label.css-label-wrong {
        background-position: 0 -49px;
    }

    .quizz input[type=checkbox].css-checkbox + label.css-label-cross {
        padding-left:29px;
        height:24px;
        display:inline-block;
        line-height:20px;
        background-repeat:no-repeat;
        background-position: 0 0;
        font-size: 16px;
        vertical-align:middle;
        cursor:pointer;
    }
    :disabled {
        cursor: default;
    }

    .questionnaire-button {
        background-color: #0073bc;
        margin-left: 40%;
        width: 22%;
        padding: 2% 0;
        Font-size: 18px;
        color: white;
        border-radius: 30px;
        animation: qpulse 2s linear alternate infinite;
    }

    @keyframes qpulse {
        from {
            background: #0073bc;
        }

        50% {
            /*fill: #30a3ec;*/
            background: #30a3ec;
        }

        to {
            background: #0073bc;
        }
    }

</style>



// WEBPACK FOOTER //
// Category.vue?1abaabb0